export default "__VITE_ASSET__aKzlLX3gDVkvwj4SvITcuQ__"